'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import config from 'pub_config';

interface i_toolip_img_url {
    (name: string): string;
}

const {url2md5} = config;
export const toolip_img_url: i_toolip_img_url = name=>url2md5(`/www/toolip/pub/img/${name}`);
